// @flow

export const Selectors = Object.freeze({
  AppContent: '#amkt-frontend-content',
  InitialState: '#initial-state',
  InitialCSS: '#critical-css',
  HtmlHead: 'head',
});

export const EMOTION_CACHE_KEY = 'amkt-frontend-ssr';
